module.exports = __webpack_public_path__ + "assets/img/16_1806.474c5827.jpg";